import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/GENERAL/iwwgeneral";
import TODIS_FORM_INFRA from "./form/NIWW/infrastructure";
import TODIS_FORM_OPS from "./form/NIWW/operations";
import TODIS_FORM_TENCOMPLIANCE from "./form/NIWW/tencompliance";
import TODIS_FORM_MAINT from "./form/NIWW/maintenace";
import { TODIS_FORM_FIELD, TODIS_FORM_DSC } from "../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";
import TODIS_FORM_ENV_IWW from "./form/NIWW/environment";
import TODIS_FORM_OTHER_IWW from "./form/NIWW/other";
import { loadModules } from 'esri-loader';


const TODIS_FORM_NP = ({ errors, touched, status, setFieldValue, values }) => {

    const [statusTabDisabled, setStatusTabDisabled] = useState(true)


    useEffect(() => {
        try {
            const [Query, query] = loadModules(["esri/rest/support/Query", "esri/rest/query"]);
            console.log("Modules loaded", Query, query);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/7";
            console.log("Query URL:", queryUrl);

            let queryObject = new Query();
            queryObject.where = `npm_iww_id=${values.npmIwwId}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            const results = query.executeQueryJSON(queryUrl, queryObject);

            if (results.features.length > 0) {
                setStatusTabDisabled(false);
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }

    })

    const generalTooltip = (
        <Tooltip id="general-tooltip">
            General data
        </Tooltip>
    );

    const infraTooltip = (
        <Tooltip id="infra-tooltip">
            Infrastructure characteristics
        </Tooltip>
    );

    const tentTooltip = (
        <Tooltip id="tent-tooltip">
            Compliance with the relevant TEN-T standards
        </Tooltip>
    );

    const operationsTooltip = (
        <Tooltip id="operations-tooltip">
            Operations related data
        </Tooltip>
    );

    const safetyTooltip = (
        <Tooltip id="safety-tooltip">
            Safety related data
        </Tooltip>
    );

    const maintTooltip = (
        <Tooltip id="maint-tooltip">
            Maintenance related data
        </Tooltip>
    );

    const environmentTootltip = (
        <Tooltip id="environment-tooltip">
            Environment related data
        </Tooltip>
    );

    const otherTootltip = (
        <Tooltip id="environment-tooltip">
            Other parameters related data
        </Tooltip>
    );

    return (

        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">

            <Tab eventKey="General" title={
                <OverlayTrigger placement="bottom" overlay={generalTooltip}>
                    <div>General</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL errors={errors} touched={touched} disabled={status} setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status} />
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>

            <Tab eventKey="section 3" title={
                <OverlayTrigger placement="bottom" overlay={infraTooltip}>
                    <div>Infrastructure</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_INFRA errors={errors} touched={touched} disabled={status} sectionData={values.iwwNpmInfraDTO} setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="TENT" title={
                <OverlayTrigger placement="bottom" overlay={tentTooltip}>
                    <div>TEN-T Compliance</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_TENCOMPLIANCE errors={errors} touched={touched} disabled={status} setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="iwwImpPmTentcompDTO.remarks" label="Remarks" name="iwwImpPmTentcompDTO.remarks" disabled={status} />
                            {errors.iwwImpPmTentcompDTO && errors.iwwImpPmTentcompDTO.remarks && touched.iwwImpPmTentcompDTO && touched.iwwImpPmTentcompDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.iwwImpPmTentcompDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Operations" title={
                <OverlayTrigger placement="bottom" overlay={operationsTooltip}>
                    <div>Operations</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_OPS errors={errors} touched={touched} disabled={status} />
            </Tab>
            <Tab eventKey="Maintenance" title={
                <OverlayTrigger placement="bottom" overlay={maintTooltip}>
                    <div>Maintenance</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_MAINT errors={errors} touched={touched} disabled={status} />
            </Tab>
            <Tab eventKey="Environmental" title={
                <OverlayTrigger placement="bottom" overlay={environmentTootltip}>
                    <div>Environmental Impact</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_ENV_IWW errors={errors} touched={touched} disabled={status} TypeForm="iwwNpmEnvDTO" />
                    </Row>
                </Container>
            </Tab>
            {statusTabDisabled ? null :
                <Tab eventKey="Other" title={
                    <OverlayTrigger placement="bottom" overlay={otherTootltip}>
                        <div>Others</div>
                    </OverlayTrigger>
                }>
                    <Container>
                        <Row>
                            <TODIS_FORM_OTHER_IWW errors={errors} touched={touched} disabled={status} TypeForm="iwwNpmOtherDTO" values={values} />
                        </Row>
                    </Container>
                </Tab>
            }
        </Tabs>
    )
}

export default TODIS_FORM_NP;